<template>
  <div>
    <div class="document-container">
      <div class="columns">
        <div class="column">
          <div class="document">
            <div class="header">
              <EsHeader>
                <template #header>
                  <div class="header-title">
                    General
                  </div>
                  <div class="header-subtitle">
                    View General Profile Information
                  </div>
                </template>
              </EsHeader>
            </div>
            <div class="content">
              <es-form>
                <template #es-form-header>
                  <div class="header-container">
                    <div class="header-elements">
                      <font-awesome-icon :icon="['fas', 'map-marker-alt']" size="lg"/>
                    </div>
                    <div class="header-elements">
                      <h6 class="title">
                        Location Information
                      </h6>
                    </div>
                  </div>
                </template>
                <template #es-form>
                  <div class="row">
                    <div class="field is-horizontal">
                      <div class="field-label is-normal">
                        <label class="label">
                          {{ getFieldLabel(`PER:${personType}:${activeModule.spec}:DISTRICT_CODE`) }} Name
                        </label>
                      </div>
                      <div class="field-body">
                        <div class="field has-text-left top-padding">
                          {{ district.location.name }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="field is-horizontal">
                      <div class="field-label is-normal">
                        <label class="label">
                          {{ getFieldLabel(`PER:${personType}:${activeModule.spec}:DISTRICT_CODE`) }} Code
                        </label>
                      </div>
                      <div class="field-body">
                        <div class="field has-text-left top-padding">
                          {{ district.code }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="field is-horizontal">
                      <div class="field-label is-normal">
                        <label class="label">
                          Address
                        </label>
                      </div>
                      <div class="field-body">
                        <div class="field has-text-left top-padding">
                          {{ district.location.street1 }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="field is-horizontal">
                      <div class="field-label is-normal">
                        <label class="label">
                          City
                        </label>
                      </div>
                      <div class="field-body">
                        <div class="field has-text-left top-padding">
                          {{ district.location.city }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="field is-horizontal">
                      <div class="field-label is-normal">
                        <label class="label">
                          State
                        </label>
                      </div>
                      <div class="field-body">
                        <div class="field has-text-left top-padding">
                          {{ district.location.stateCode }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row no-border">
                    <div class="field is-horizontal">
                      <div class="field-label is-normal">
                        <label class="label">
                          Zip
                        </label>
                      </div>
                      <div class="field-body">
                        <div class="field has-text-left top-padding">
                          {{ district.location.zip }}
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </es-form>
              <es-form style="padding-top: 0">
                <template #es-form-header>
                  <div class="header-container">
                    <div class="header-elements">
                      <font-awesome-icon :icon="['fas', 'address-book']" size="lg"/>
                    </div>
                    <div class="header-elements">
                      <h6 class="title">
                        Contact Information
                      </h6>
                    </div>
                  </div>
                </template>
                <template #es-form>
                  <div class="row">
                    <div class="field is-horizontal">
                      <div class="field-label is-normal">
                        <label class="label">
                          First Name
                        </label>
                      </div>
                      <div class="field-body">
                        <div class="field has-text-left top-padding">
                          {{ district.location.adminFirstName }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="field is-horizontal">
                      <div class="field-label is-normal">
                        <label class="label">
                          Last Name
                        </label>
                      </div>
                      <div class="field-body">
                        <div class="field has-text-left top-padding">
                          {{ district.location.adminLastName }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="field is-horizontal">
                      <div class="field-label is-normal">
                        <label class="label">
                          Title
                        </label>
                      </div>
                      <div class="field-body">
                        <div class="field has-text-left top-padding">
                          {{ district.location.adminTitle }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="field is-horizontal">
                      <div class="field-label is-normal">
                        <label class="label">
                          Email
                        </label>
                      </div>
                      <div class="field-body">
                        <div class="field has-text-left top-padding">
                          {{ district.location.adminEmail }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row no-border">
                    <div class="field is-horizontal">
                      <div class="field-label is-normal">
                        <label class="label">
                          Phone
                        </label>
                      </div>
                      <div class="field-body">
                        <div class="field has-text-left top-padding">
                          {{ district.location.adminPhone }}
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </es-form>
            </div>
          </div>
        </div>
        <div class="column is-one-quarter" v-if="activeModule.name === 'personId'">
          <div class="document">
            <div class="header">
              <EsHeader>
                <template #header>
                  <div class="header-title">
                    Next Steps
                  </div>
                </template>
              </EsHeader>
            </div>
            <div class="is-flex flex-direction--column flex-align--start" style="padding: 1rem">
              <!-- <a
                @click.prevent="$router.push({ name: 'PIDistrictInfoDownloadOptions' })"
                @keypress.prevent="$router.push({ name: 'PIDistrictInfoDownloadOptions' })"
                tabindex="0"
                role="button"
              >
                Download Person Records for this location
              </a> -->
              Download Person Records for this location
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { mapGetters } from 'vuex';
import {
  faMapMarkerAlt,
  faAddressBook,
} from '@fortawesome/pro-solid-svg-icons';
import EsForm from '@/components/EsForm.vue';
import EsHeader from '@/components/EsHeader.vue';
import FieldLabels from '@/mixins/FieldLabels';
import NotificationManager from '@/mixins/NotificationManager';

library.add(
  faMapMarkerAlt,
  faAddressBook,
);
export default {
  props: {
    district: {
      type: Object,
    },
  },
  mixins: [
    FieldLabels,
    NotificationManager,
  ],
  components: {
    EsForm,
    EsHeader,
  },
  computed: {
    ...mapGetters({
      activeModule: 'appModules/getActiveModule',
      allModules: 'appModules/getAllModules',
    }),
    ...mapGetters('lookups', [
      'defaultPersonType',
    ]),
    address() {
      const { street1 } = this.district.location;
      const { street2 } = this.district.location;
      return `${street1 || ''} ${street2 ? `, ${street2}` : ''}`;
    },
  },
  data() {
    return {
      personType: null,
    };
  },
  async created() {
    this.setDataElements();
  },
  methods: {
    setDataElements() {
      this.personType = this.defaultPersonType;
    },
  },
};
</script>

<style lang="sass" scoped>
  .top-padding
    padding-top: 0.375rem
  .no-border
    border: 0
</style>
